<template>
  <b-form-group class="filter-labels" :label="label">
    <div class="flex">
      <blumar-decimal-input class="spread" v-if="isDecimal" v-model="localValue" size="md"/>
      <b-form-input class="spread" v-else v-model="localValue"/>
    </div>
  </b-form-group>
</template>

<script>
export default {
  props: ['label', 'value', 'decimal'],
  computed: {
    isDecimal() { return this.decimal || this.decimal === ''; },
    localValue: {
      get() { return this.value; },
      set(value) { this.$emit('input', value); }
    }
  }
}
</script>

<style>

.filter-labels {
  color: white;
  margin: 0 20px;
  flex: 1 !important;
}

.flex {
  display: flex;
}

.spread {
  width: unset !important;
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/FilterInput.vue